<template>
  <static-fullscreen-card>
    <template v-slot:title>
      <small> (#{{ data.id }})</small> Сделка №{{ data.code_doc }} [{{ statusCurrent.text }}]
    </template>
    <template v-slot:actions>
      <a-btn-status v-if="getAccess('agentSell.status', { data })" :items="statusItems" @click="clickStatus($event)" :disabled="loading" />
      <a-btn-edit v-if="canEdit && data.status != 2" title="Редактирование" @click="clickEdit" />
      <a-btn-delete
        v-if="
          id &&
          data.status !== 2 &&
          getAccess('agentSell.delete', {
            users: [data.createdby_id],
          })
        "
        @click="onDelete"
      />
    </template>
    <portal to="v-goup" v-if="idShow && !isQuickView">
      <v-btn class="mr-3" fab small @click="$emit('close', data)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </portal>
    <portal to="v-main">
      <s-edit-form v-if="canEdit" v-model="showEditDialog" :m="m" :configForm="{ head: configHead, title: configHead.title, api: url }" :id="id" :opt="{}" />
      <s-quick-addDocument v-if="showAddDocDialog" v-model="showAddDocDialog" :id="id" :api="url" :modelDoc="addDocModel" />
    </portal>
    <v-row v-if="!loading">
      <v-col cols="12" sm="6">
        <material-card color="secondary">
          <template v-slot:heading>
            <div class="px-3 py-1">Объект</div>
          </template>
          <a-form-view :value="data" :model="calcModel('viewLeft')" :config="{ dense: true }" />
        </material-card>
      </v-col>
      <v-col cols="12" sm="6">
        <material-card color="secondary">
          <template v-slot:heading>
            <div class="px-3 py-1">Информация по сделке</div>
          </template>
          <a-form-view :value="data" :model="modelRight" :config="{ dense: true }" />
        </material-card>
      </v-col>
      <v-col cols="12" v-if="!loading">
        <material-card color="third" class="block_detail">
          <template v-slot:heading>
            <v-tabs v-model="tab" background-color="transparent" slider-color1="white" show-arrows center-active @change="changeTab(tab)">
              <v-tab v-for="(tab, i) in tabs" :key="i" v-if="showTab(tab.name)" class="mr-3">{{ tab.title }} </v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab" class="transparent" style="min-height: 200px">
            <v-tab-item v-for="(tab, i) in tabs" :key="i" v-if="showTab(tab.name)" :data-name="`${tab.name} section`">
              <TabDocs
                v-if="'docs'.split(',').includes(tab.name)"
                props="allFiles"
                :data="data"
                :m="m"
                :category="showDocs(tab.name)"
                @addDocs="addNewDocs(tab.name)"
                :height="detailHeight"
              />

              <TabBalance v-if="tab.name == 'balance'" :data="{ data, id }" :height="detailHeight" />
              <s-tabs-cash v-if="tab.name == 'cashOut'" :data="data" type="out" :canAdd="data.status == 2" :m="m" :height="detailHeight" />
              <s-tabs-cash v-if="tab.name == 'cashIn'" :data="data" type="in" :canAdd="data.status == 2" :m="m" :height="detailHeight" />
              <comment-view v-if="tab.name == 'comments'" :id="id || 0" :targetName="'rent'" :needUpdate="needUpdateComments" :height="detailHeight" />
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
    <div v-if="loading" class="loading-block">
      <div class="loader"></div>
    </div>
  </static-fullscreen-card>
</template>

<script>
import { statusChange, getAccess, autoHeightBlock, removeEl, genModel } from "@/components/mixings";
export default {
  mixins: [getAccess, statusChange, autoHeightBlock, removeEl, genModel],
  components: {
    TabDocs: () => import("./tabs/tabDocs"),
  },
  props: {
    idShow: Number,
    isQuickView: { type: Boolean, default: false },
  },
  data() {
    return {
      id: 0,
      needUpdateComments: 0,
      loading: true,
      showAddDocDialog: false,
      addDocModel: null,

      showEditDialog: false,
      title: "",
      data: {},
      m: this.$store.getters["config/get"].models.agentSell,
      tab: 0,
      initEditDialog: 0,
    };
  },
  created() {
    this.loading = true;
    if (!this.isQuickView) {
      this.$root.title = this.m.title;
    }
    this.id = this.idShow || Number(this.$route.params.id);
    this.fitchData();
    if (!this.isQuickView) {
      if (this.$attrs?.tab) {
        this.tab = parseInt(this.$attrs.tab);
      }
    }
  },
  watch: {
    initEditDialog(v) {
      if (v == 1) {
        this.$nextTick(() => {
          this.showEditDialog = true;
        });
      } else {
        this.showEditDialog = true;
      }
    },
    showEditDialog() {
      if (!this.showEditDialog) {
        this.fitchData();
      }
    },
    showAddDocDialog(v) {
      if (!v) {
        this.fitchData();
      }
    },
  },
  computed: {
    url() {
      return this.m.api;
    },
    statuses() {
      return this.m.statuses;
    },
    statusItems() {
      let items = [];
      let res = [];
      let status = {};
      let type;
      type = "status";
      status = this.getStatus(type);
      if (status?.["next"]) {
        res = [
          ...res,
          ...this.statuses.filter((s) => {
            return status.next.includes(s.value) && s.field == type;
          }),
        ];
      }

      items = JSON.parse(JSON.stringify(res));

      return items;
    },
    statusCurrent() {
      let idx = this.statuses.findIndex((el) => {
        return el.value == this.data.status && el.field == "status";
      });
      if (idx == -1) return {};
      return JSON.parse(JSON.stringify(this.statuses[idx]));
    },
    model: {
      get() {
        let model = this.getModelList(this.m, "form", true);
        console.log("model", model);
        return model;
      },
    },
    modelRight() {
      return this.calcModel("viewForm1");
    },
    tabs() {
      let tabs = [
        { name: "cashIn", title: "Приход", show: true },
        { name: "cashOut", title: "Расход", show: true },
        { name: "docs", title: "Документы", show: true },
        { name: "comments", title: "Комментарии", show: true },
        { name: "acc", title: "Проводки", show: this.getAccess("agentSell.accounting") },
      ];
      return tabs;
    },

    canEdit() {
      return this.getAccess("agentSell.edit", { data: this.data });
    },
    configHead() {
      let config = JSON.parse(JSON.stringify(this.m?.config.createForm || {}));
      return config || {};
    },
  },
  methods: {
    clickEdit() {
      this.showEditDialog = true;
    },
    getStatus(type) {
      let idx = this.statuses.findIndex((el) => {
        return el.value == this.data[type] && el.field == type;
      });
      if (idx == -1) return {};
      return JSON.parse(JSON.stringify(this.statuses[idx]));
    },
    showTab(n) {
      if (n == "acc") return false;
      return true;
    },
    showDocs(field) {
      return this.model.find((el) => el.name == field)?.category || -1;
    },
    addNewDocs(field) {
      this.addDocModel = this.model.find((el) => el.name == field) || null;
      if (!this.addDocModel) return;
      this.showAddDocDialog = true;
    },
    changeTab(tab) {
      if (!this.idShow) this.$router.push({ query: { tab } });
    },
    async fitchData() {
      const d = await this.$axios.get(this.url + "/" + this.id);
      if (d.data && d.data.data) {
        this.data = d.data.data;
      }
      this.loading = false;
    },

    updateData() {
      this.fitchData();
    },

    async onDelete() {
      const ok = await this.$root.$confirm({
        title: "Удаление",
        message: ["Вы действительно хотите удалить эту сделаку?"],
        okButton: "Да",
        cancelButton: "Нет",
      });
      if (!ok) return;
      this.remove(this.url, this.id);
    },
    afterRemove(data) {
      this.removeDialogShow = false;
      if (this.idShow) this.$emit("close", data);
      else this.$router.push({ name: "agentSell" });
    },
  },
};
</script>

<style lang="sass"></style>
